module.exports = "<p>\n    {{quantity}}\n</p>\n"